<ul class="settings-container">
  <li *ngFor="let setting of settings" (click)="setting.callback(); visibilityChange.emit(false)" class="settings-item">
    <div class="margin-wrap">
      <div class="icon" [style.--icon]="getIconUrl(setting.icon)"></div>
      <p>{{setting.title}}</p>
    </div>
  </li>
</ul>
